import {
    Directive,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
    inject
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";

@Directive({ selector: "[raskHasRole]" })
export class HasRoleDirective implements OnInit, OnDestroy {
    @Input() raskHasRole: string[];

    private readonly authenticationService = inject(AuthenticationService);
    private readonly destroySrc = new Subject<void>();
    private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);

    private visible = false;

    ngOnDestroy(): void {
        this.destroySrc.next();
    }

    ngOnInit(): void {
        this.authenticationService.userStateChanged.pipe(
            takeUntil(this.destroySrc)
        ).subscribe(() => {
            const previouslyVisible = this.visible;
            const visible = this.authenticationService.hasAnyRole(this.raskHasRole);

            if(visible && !previouslyVisible) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else if(!visible) {
                this.viewContainer.clear();
            }
            this.visible = visible;
        });
    }
}
